import ICONS from '@/assets/icons';
import { cn } from '@/utils/methods';
import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaTimesCircle, FaEye } from 'react-icons/fa';

interface StatusChipProps {
  status: string;
  className?: string;
}

export const StatusChip = ({ status, className }: StatusChipProps) => {
  const normalizedStatus = status.toLowerCase();
  const isSuccess = ['connected', 'active'].includes(normalizedStatus);
  let Icon = FaCheckCircle;
  let color = "";

  switch (normalizedStatus) {
    case "connected":
    case "active":
    case "replied":
      color = "bg-green-light text-green-dark";
      Icon = ICONS.GreenCircleCheck;
      break;
    case "failed":
      color = "bg-red-light text-red-dark";
      Icon = ICONS.RedTriangle;
      break;
    case "sent":
      color = "bg-table-header-bg text-primary-black";
      Icon = ICONS.GreenCircleCheck;
      break;
    case "opened":
      color = "bg-yellow-light text-yellow-dark";
      Icon = FaEye;
      break;
    case "registeration failed":
      color = "bg-red-light  text-red-dark";
      Icon = ICONS.RedCircleCheck;
      break;
    default:
      color = "bg-red-light text-red-dark";
      Icon = ICONS.RedCircleCheck;
      break;
  }

  return (
    <span className={cn(`flex items-center space-x-1.5 px-2.5 py-1.5 w-fit rounded-[6px] text-[12px] font-semibold ${color}`, className)}>
      <Icon size={10} />
      <span className="capitalize leading-3">{status.replace(/_/g, ' ')}</span>
    </span>
  );
};
